// Whether a stored URL is safe to put in the DOM as an href.
//
// recipes.url is free text: the import path only ever writes an https URL that
// passed the Edge Function's SSRF guard, but any household member can write the
// column directly through PostgREST. A `javascript:` href there would run in the
// PWA's own origin — where the Supabase session lives — for every member who
// taps it. React does not block those (it warns and renders), so the scheme is
// checked here instead.

/** The URL unchanged when it is http(s), else null — never render a null href. */
export function safeHttpUrl(raw: string | null | undefined): string | null {
  if (!raw) return null
  let parsed: URL
  try {
    parsed = new URL(raw)
  } catch {
    return null
  }
  return parsed.protocol === 'https:' || parsed.protocol === 'http:' ? raw : null
}
